'use client';

import Image from 'next/image';
import Link from 'next/link';

export default function IndexNavbar() {
  // const baseLinkClass =
  //   'flex h-[32px] w-[96px] px-3 items-center justify-center rounded text-xs hover:text-sm font-bold uppercase shadow outline-none transition-all duration-150 ease-linear hover:shadow-lg focus:outline-none transform hover:scale-105';

  return (
    <nav className="p-2 flex h-auto w-full content-center items-center">
      <div className="mx-5 flex w-full items-center justify-between">
        {/* Left side link */}
        <Link href="/">
          <Image
            src="/images/logos/logo.png"
            alt="Adequa : L'expérience a de l'avenir"
            width={344}
            height={77}
            className="font-petita-bold text-xl sm:mx-4 md:mx-8 content-center uppercase"
          />
        </Link>

        {/* Right side links */}
        {/* <div className="gap-1 flex">
          <Link
            className={`${baseLinkClass} text-stonerwhite bg-policeblue hover:bg-policebluebg`}
            href="/talent/login"
          >
            Talent
          </Link>

          <Link
            className={`${baseLinkClass} text-policeblue border-policeblue border hover:border-2`}
            href="/company/login"
          >
            Entreprise
          </Link>
        </div> */}
      </div>
    </nav>
  );
}
